// F13-E7 — helpers PUROS da superfície de sessão (kind-aware), extraídos do
// SessionWorkspace pra manter o dp-loc no baseline. 'chat' | 'code' | null.

/** kind da sessão ('chat'|'code'|…) ou null. */
export function sessionKindOf(session) {
  return (session && session.kind) || null;
}

/** True quando a sessão é da aba Chat. */
export function isChatSession(session) {
  return sessionKindOf(session) === 'chat';
}

/** F13-E7-T09 — chat sem pasta explícita roda SEM root (nada de auto-bind). */
export function chatSansFolderOf(session, root) {
  return isChatSession(session) && !String(root || '').startsWith('/');
}
